import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import "../not-found/style.scss";
import { ErrorTemplate } from "../../components/error-template/error-template.comp";

const ErrorPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const title = searchParams.get("title");
    const description = searchParams.get("description");

    useEffect(() => {
        if (!title || !description) {
            navigate("/404");
        }
    }, [navigate, title, description]);

    return <ErrorTemplate title={title ?? ""} description={description ?? ""} />;
};

export default ErrorPage;
